import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/app/routes";
const changedAccountNos = new Set<string>();

export function markAddressChanged(accountNo: string): void {
  changedAccountNos.add(accountNo);
}
export function useAddressChangeGuard(accountNo: string | undefined): boolean {
  const navigate = useNavigate();
  const changed = accountNo !== undefined && changedAccountNos.has(accountNo);

  useEffect(() => {
    if (!changed) {
      return;
    }
    void navigate(ROUTES.settings.accountDocumentAddress, { replace: true });
  }, [changed, navigate]);

  return changed;
}
